//用户信息管理

export default {
  //用户的token，用来发送axios请求
  tokenMsg (state) {
    return state.userLoginMessage.token
  },
  //用户的登录身份信息
  userInfo (state) {
    if (state.userLoginMessage.socketType === 'admin') return { type: 99, en: 'admin', cn: '管理员' };
    switch (state.userLoginMessage.level*1) {
      case 1:return { type: 2, en: 'travel', cn: '企业',level:1}
      case 2:
        if(state.userLoginMessage.type==2){
          return { type: 2, en: 'travel', cn: '企业',level:1}
        }else{
          return { type: 3, en: 'hotel', cn: '企业',level:2}
        }
      case 3:
        if(state.userLoginMessage.level==3&&state.userLoginMessage.type==3){
          return { type: 3, en: 'tourguide', cn: '销售',level:3}
        }else{
          return { type: 2, en: 'homestay', cn: '采购',level:3}
        }
        
      case 4:return { type: 2, en: 'homestay', cn: '个人',level:4}
      default:return {}
    }
  },
  //用户是否为集团账号
  isGroup (state) {
    return Number(state.userLoginMessage.level)==2||Number(state.userLoginMessage.level)==1
  },
  //用户登录注册信息
  info_store_arr (state) {
    return state.userLoginMessage.info_store_arr || {}
  },
  //多个集团账号
  // someGroup (state) {
  //   return (Number(state.userLoginMessage.group_id) > 0) && (state.userLoginMessage.store_ids.length > 1)
  // },
  //本地缓存当前查看的门店信息，单门店用户刷新页面时currentStoreInfo清空，默认根据登录信息设置当前门店信息
  storeInfo (state) {
    //如果是数组则转为字符串
    if (Array.isArray(state.userLoginMessage.store_id_arr)) {
      state.userLoginMessage.store_id_arr = state.userLoginMessage.store_id_arr.join(',')
    }else{
      state.userLoginMessage.store_id_arr = state.userLoginMessage.store_id_arr||"";
    }
    let id = state.userLoginMessage.store_id_arr;
    
    if(state.userLoginMessage.level==3&&state.userLoginMessage.type==3){  
      id=state.userLoginMessage.storeId||0
    }
    let c = state.currentStoreInfo.verify + '',
        s = state.StoreBasicInfo.verify + '',
        u = state.userLoginMessage.verify ? (state.userLoginMessage.verify + '') : '';
    let storeVerify = c || s || u;
    return {
      // num: res.data.num,                     //当前用户Id
      type: state.currentStoreInfo.type || state.userLoginMessage.type,                      //当前门店类型
      storeId: state.currentStoreInfo.storeId || id||"0",                                         //当前门店Id
      // grostoreId: (state.userLoginMessage.group_id>0) ? state.userLoginMessage.store_id_arr.join(',') : '',  //专属集团用户的storeid
      verify: Number(storeVerify),                                                           //当前门店认证状态
      openId: state.currentStoreInfo.openId || state.userLoginMessage.wechat_openid,         //当前门店的微信openId
      level: state.currentStoreInfo.level || state.userLoginMessage.level,                   //当前门店等级
    }
  },
  //未读消息总数
  unReadMsg(state) {
    return Number(state.unReadTrade);
    // return Number(state.unReadTrade) + Number(state.unReadSys);
  },
    //未读消息总数
  unReadMsg(state) {
    return Number(state.unReadTrade);
    // return Number(state.unReadTrade) + Number(state.unReadSys);
  },
  //认证状态
  verify (state) {
    return Number(state.userHeadInfo.verify);
  },
  //认证状态
  uid (state) {
    return Number(state.userLoginMessage.uid);
  }
}
